import { createTheme } from "@mui/material";

interface AdditionalColors {
  pastelBlue: string;
  deepGreen: string;
}

interface CustomColor {
  50?: string;
  100?: string;
  150?: string;
  200?: string;
  250?: string;
  300?: string;
  400?: string;
  500?: string;
  550?: string;
  600?: string;
  700?: string;
  750?: string;
  800?: string;
  850?: string;
  900?: string;
  WBG1?: string;
  WBG2?: string;
  WBG3?: string;
  WBG4?: string;
  WBG5?: string;
  WBG6?: string;
}

declare module "@mui/material/styles" {
  interface Theme {
    additionalColors: AdditionalColors;
    brand1: CustomColor;
    brand2: CustomColor;
    black: CustomColor;
    grey1: CustomColor;
    grey2: CustomColor;
    whiteBg: CustomColor;
    yellow: CustomColor;
    red: CustomColor;
    blue: CustomColor;
    purple: CustomColor;
    pink: CustomColor;
  }

  interface ThemeOptions {
    additionalColors: AdditionalColors;
    brand1: CustomColor;
    brand2: CustomColor;
    black: CustomColor;
    grey1: CustomColor;
    grey2: CustomColor;
    whiteBg: CustomColor;
    yellow: CustomColor;
    red: CustomColor;
    blue: CustomColor;
    purple: CustomColor;
    pink: CustomColor;
  }
}

export const theme = createTheme({
  palette: {
    primary: {
      main: "#6DA588",
    },
    secondary: {
      main: "#E69394",
    },
  },

  additionalColors: {
    pastelBlue: "#b3bcc8",
    deepGreen: "#22382D",
  },

  brand1: {
    50: "#DFEBE5",
    100: "#D2E3DA",
    150: "#C5DBD0",
    200: "#B9D4C6",
    250: "#E7F1EC",
    300: "#9FC4B1",
    400: "#86B59D",
    500: "#6DA588",
    600: "#578D71",
    700: "#45715A",
    750: "#3D634F",
    800: "#345444",
    850: "#2B4638",
    900: "#22382D",
  },
  brand2: {
    50: "#F7DEDE",
    100: "#F5D5D6",
    150: "#F3CDCD",
    200: "#F2C5C5",
    300: "#EEB4B5",
    400: "#EAA4A4",
    500: "#E69394",
    600: "#E17E7F",
    700: "#DC6A6B",
    750: "#DA5F61",
    800: "#D85556",
    850: "#D54B4C",
    900: "#D34042",
  },
  black: {
    500: "#808080",
    550: "#7C7E89",
    600: "#696969",
    700: "#525252",
    750: "#474747",
    800: "#242424",
  },
  grey1: {
    50: "#DCDCDC",
    100: "#D2D2D2",
    150: "#C7C7C7",
    200: "#BDBDBD",
    300: "#A9A9A9",
    400: "#949494",
  },
  grey2: {
    50: "#EFF0F3",
    100: "#E3E6EB",
    150: "#D7DBE2",
    200: "#CBD1D9",
    300: "#B3BCC8",
    400: "#9CA7B7",
    500: "#8492A6",
  },
  whiteBg: {
    WBG1: "#FFFFFF",
    WBG2: "#FAFBFE",
    WBG3: "#EEF2FB",
    WBG4: "#DDE5F7",
    WBG5: "#CDD9F3",
    WBG6: "#C5D2F1",
  },
  blue: {
    50: "#FFFFFF",
    100: "#E6F1FF",
    150: "#BEDBFE",
    200: "#96C5FD",
    300: "#69ACFC",
    400: "#3C93FB",
    500: "#2587FB",
    600: "#0464D7",
  },
  red: {
    50: "#FFF9F9",
    100: "#FED1D1",
    150: "#FEA9A9",
    200: "#FD8181",
    300: "#FC5454",
    400: "#FC2727",
    500: "#FB1010",
    600: "#C30303",
  },
  pink: {
    50: "#FBEFF5",
    100: "#F2CEE1",
    150: "#EAAECE",
    200: "#E18EBA",
    300: "#D76AA4",
    400: "#CE458E",
    500: "#C73583",
    600: "#91265F",
  },
  purple: {
    50: "#FFFFFF",
    100: "#E9E9FF",
    150: "#C2C1FE",
    200: "#9B99FD",
    300: "#6F6CFC",
    400: "#433FFB",
    500: "#2D28FB",
    600: "#0904DA",
  },
  yellow: {
    50: "#FFFFFF",
    100: "#FDF5E5",
    150: "#FBE6BF",
    200: "#F8D799",
    300: "#F5C66E",
    400: "#F2B543",
    500: "#F1AD2E",
    600: "#CB8A0E",
  },
});
